import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

import Utils from '../common/Utils';

class Sliders {
    constructor() {
        this.init();
    }

    init() {
        this.latestNewsSlider();
        this.mediaSlider();
        this.homeSlider();
    }

    latestNewsSlider() {
        const $slider = $('.news-grid.news-grid--slider');
        if (!$slider.length) return false;

        let opt = {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            prevArrow: `<i class="icon prev-arrow slick-navigate icon-next"></i>`,
            nextArrow: `<i class="icon next-arrow slick-navigate icon-next"></i>`,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 740,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        };

        let slidesToShow = $slider.attr('data-slidesToShow') || 4;
        let slidesToScroll = $slider.attr('data-slidesToScroll') || 4;
        opt['slidesToShow'] = parseInt(slidesToShow);
        opt['slidesToScroll'] = parseInt(slidesToScroll);
        $slider.slick(opt);

        Utils.bindEvent('tabChange', (e, source) => {
            let currentTab = $(source);
            setTimeout(() => {
                if (!currentTab.find('.news-grid').hasClass('slick-initialized')) {
                    currentTab.find('.news-grid').slick(opt);
                } else if (typeof currentTab.find('.slick-track') != undefined && currentTab.find('.slick-track').width() == 0) { // fix after resize
                    currentTab.find('.news-grid').slick('reinit');
                } else {
                    return false;
                }
            }, 100)
        })
    }

    mediaSlider() {
        const $slider = $('.media-slider');
        if (!$slider.length) return false;

        let opt = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            prevArrow: `<div class="slick-navigate--helper prev"><i class="icon prev-arrow slick-navigate icon-next"></i></div>`,
            nextArrow: `<div class="slick-navigate--helper next"><i class="icon next-arrow slick-navigate icon-next"></i></div>`
        };

        $slider.slick(opt);
    }

    homeSlider() {
        const $slider = $('.home-js-slider');
        if (!$slider.length) return false;

        let opt = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            prevArrow: `<div class="slick-navigate--helper prev"><i class="icon prev-arrow slick-navigate icon-next"></i></div>`,
            nextArrow: `<div class="slick-navigate--helper next"><i class="icon next-arrow slick-navigate icon-next"></i></div>`
        };

        $slider.slick(opt);
    }
}

export default Sliders;



// WEBPACK FOOTER //
// ./src/assets/js/components/Sliders.js